export const PromocodesCollection = [
    {
        id: 1,
        code: 'newRS',
        title_ru: 'Новый покупатель.',
        title_en: 'New customer.',
        discount: 5,
    },
    {
        id: 2,
        code: 'ktulhu666',
        title_ru: 'Поклонник Лафкравта.',
        title_en: 'A fan of Lafkravt.',
        discount: 10,
    },
    {
        id: 3,
        code: 'tabletop2023',
        title_ru: 'Новый год с новыми играми!',
        title_en: 'New Year with new games!',
        discount: 12,
    },
    {
        id: 4,
        code: 'inviteRS',
        title_ru: 'Вместе веселее!',
        title_en: "It's more fun together!",
        discount: 4,
    },
    {
        id: 5,
        code: 'salesalesale',
        title_ru: 'Щедрость.',
        title_en: 'Generosity.',
        discount: 1,
    },
    {
        id: 6,
        code: 'student1',
        title_ru: 'Ну тут -200.',
        title_en: 'Here is -200.',
        discount: 0,
    },
];
